export class ImportField {
    constructor(public fieldName:string, public displayName:string, public required:boolean, public selectedValue:string) {
        var oeueueuouoeuoe = 3;
    }

    static parseJson(json:any):ImportField {
        var entity:ImportField = new ImportField(
            json.fieldName,
            json.displayName,
            json.required,
            ""
        );
        return entity;
    }
}
